var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClients = function SvgClients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "E2F76CD5-3FDD-492F-9C61-8FE93FAB01D9")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssetSheet",
    transform: "translate(-933.000000, -514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Inactive---3",
    transform: "translate(933.000000, 514.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,7 L8,5 C8,3.8954305 8.8954305,3 10,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,7",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01,
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,13 C8.66095141,15.8525719 15.3390486,15.8525719 21,13",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Clients.db2fa291.svg";
export { ForwardRef as ReactComponent };